<!-- Header / Navbar -->
<nav class="fixed top-0 z-[1000] w-full bg-white border-b border-gray-200">
  <div class="px-3 py-3 lg:px-5 lg:pl-3 flex items-center justify-between">

    <!-- Hamburger Button (mobile) -->
    <button type="button"
      class="text-gray-700 bg-transparent border border-transparent hover:bg-gray-200 focus:ring-2 focus:ring-gray-300 font-medium rounded-lg text-sm p-2 inline-flex md:hidden"
      (click)="toggleSidebar()">
      <span class="sr-only">Open sidebar</span>
      <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5 7h14M5 12h14M5 17h10" />
      </svg>
    </button>

    <!-- Logo -->
    <a class="flex ml-3 sm:ml-0" href="#">
      <img src="assets/images/logo.svg" class="h-[30px] sm:h-[35px]" alt="LOGO" />
    </a>

    <!-- Right Section -->
    <div class="flex items-center gap-4">

      <ul class="relative flex items-center gap-2">

        <!--  Connect Wallet Button -->
        @if (appKitService.getSafeWalletAddress()) {
        <div>
          {{ appKitService.getSafeWalletAddress() | slice:0:6 }}...{{ appKitService.getSafeWalletAddress() | slice:-4 }}
        </div>
        } @else {
        <button (click)="connectWallet()">Connect Wallet</button>
        }
        <!-- Logout -->
        <li>
          <button type="button" (click)="openLogoutModal()"
            class="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded cursor-pointer">
            Logout
          </button>
        </li>

      </ul>

    </div>
  </div>
</nav>


<!-- Logout Confirmation Modal -->
@if (showModal) {
<!-- Backdrop -->
<div class="fixed inset-0 bg-black/50 z-40"></div>

<!-- Modal -->
<div
  class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg z-50 w-80 p-5">
  <h3 class="text-lg font-semibold mb-3 cursor-pointer">Logout</h3>
  <p class="mb-5 text-sm">Are you sure you want to logout?</p>

  <div class="flex justify-end gap-3">

    <button type="button" (click)="showModal = false"
      class="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300">
      No
    </button>

    <button type="button" (click)="logout()" class="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
      Yes
    </button>

  </div>
</div>
}